import React, {useEffect, useState} from "react";
import toggleOnImg from "../../Resources/Image/sd_toggle_on.svg";
import toggleOffImg from "../../Resources/Image/sd_toggle_off.svg";

const PlanModalPlanSingle = ({planText, currentPlan = "", price, selectedPlan, setSelect, showWithSMSToggle = false}) => {
    const [toggleOn, setToggleOn] = useState(true);


    const matchCurrentPlan = () => {
        return planText === currentPlan;
    }

    const checkIfSelected = () => {
        return selectedPlan?.includes(planText);
    }

    const handleClick = (ev) => {
        let planTextWithToggle = planText;
        if (showWithSMSToggle && !toggleOn) {
            planTextWithToggle += " (without sms)";
        }
        setSelect(planTextWithToggle);
    }

    const handleToggleClick = (ev) => {
        ev.stopPropagation();
        setToggleOn(!toggleOn);
        let planTextWithToggle = planText;
        if (toggleOn) {
            planTextWithToggle += " (without sms)";
        }
        setSelect(planTextWithToggle);
    }

    return (
        <div className={`p-3 border rounded single-plan ${checkIfSelected() ? 'selected-plan' : ''}`}
             onClick={handleClick}>
            <div className="fs-5 fw-bold planName">
                {planText}
                {matchCurrentPlan() && <div className="fs-6 fw-light">(Current Plan)</div>}
            </div>
            {showWithSMSToggle && <div className="d-flex justify-content-center py-2" onClick={handleToggleClick}>
                <div className="sd-toggle">
                    <img src={toggleOn ? toggleOnImg : toggleOffImg} alt={"on-off"}/>
                </div>
                <div className="ps-2">with SMS</div>
            </div>}
            {
                !showWithSMSToggle && <div className="toggle-empty-space"></div>
            }
            <div className="fs-6 fw-lighter">Starts at</div>
            <div className="fs-5 fw-bold">
                ${price}/mo
            </div>

        </div>
    )
}

export default PlanModalPlanSingle;
